import { createContext } from "react";
import { MyDriversContextProps } from "../models";

export const MyDriversContext = createContext<MyDriversContextProps>(
  {} as MyDriversContextProps
);
